import React, { FC } from "react";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { InclusionSection } from "./InclusionSection";
import { ExclusionSection } from "./ExclusionSection";
import { useProductSections } from "./useProductSections";
import { useInsideFilterChip } from "../../../../pages/Workspace/UserFilters/FiltersChips/hooks/useInsideFilterChip";
import { lightScrollbarStyle } from "../../../../styles/lightScrollbarStyle";
import { FilterLayout } from "../FilterLayout";

interface Props {
  height?: string | number;
  overflowY?: "scroll" | "auto";
}

export const ProductsFilter: FC<Props> = React.memo(
  ({ height = 500, overflowY = "scroll" }) => {
    const { insideChip, elementRef } = useInsideFilterChip();
    const {
      inclusionSections,
      exclusionProducts,
      handleInclusionProductSelect,
      handleConditionChange,
      handleExclusionProductSelect,
      handleAddSection,
      handleRemoveSection,
      handleClearFilter,
      handleFaiSelect,
      handleInstallAgeChange,
      handleIntensityChange,
    } = useProductSections();

    return (
      <FilterLayout
        title="Products"
        onClear={handleClearFilter}
        showHeader={!insideChip}
        id="products-filter"
        refProp={elementRef}
        sx={{
          overflowY,
          height,
          pr: 1,
          ...lightScrollbarStyle,
        }}
      >
        {inclusionSections.map((section) => (
          <InclusionSection
            key={section.id}
            sectionId={section.id}
            sectionIndex={section.index}
            condition={section.condition}
            selectedProductIds={section.productIds}
            canRemove={inclusionSections.length > 1}
            onConditionChange={handleConditionChange}
            onProductSelect={handleInclusionProductSelect}
            onRemoveSection={handleRemoveSection}
            isInsideTechInstall={true}
            selectedFaiIds={section.faiIds}
            onFaiSelect={handleFaiSelect}
            installAgeMonths={section.installAgeMonths}
            onInstallAgeChange={handleInstallAgeChange}
            intensity={section.intensity}
            onIntensityChange={handleIntensityChange}
          />
        ))}

        {/* Add Section Button */}
        <Button
          startIcon={<AddIcon />}
          onClick={handleAddSection}
          size="small"
          fullWidth
          sx={{ mb: 2 }}
        >
          Add
        </Button>

        {/* Exclusion Section - Always present */}
        <ExclusionSection
          selectedProductIds={exclusionProducts}
          onProductSelect={handleExclusionProductSelect}
          isInsideTechInstall={true}
        />
      </FilterLayout>
    );
  }
);
